export type CollectionUpdateMode = "nav" | "filter";

export type AfterCollectionUpdateContext = {
  mode: CollectionUpdateMode;
  scope: ParentNode;
  navParent: string | null;
  preserveSubcollectionNav?: boolean;
  headerSection?: HTMLElement | null;
  activeHandle?: string;
};

type AfterUpdateHook = (ctx: AfterCollectionUpdateContext) => void | Promise<void>;

const hooks: AfterUpdateHook[] = [];

export const registerAfterCollectionUpdate = (hook: AfterUpdateHook) => {
  hooks.push(hook);
};

export const runAfterCollectionUpdate = async (ctx: AfterCollectionUpdateContext) => {
  for (const hook of hooks) {
    await hook(ctx);
  }
};
